<template>
  <v-dialog
      :value="dialogVisible"
      @input="handleDialogInput"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
      class="d-flex flex-column"
  >
    <v-card tile class="d-flex flex-column" style="height: 100vh;">
      <div id="titulo-dialog" class="df pa-4 d-flex align-center" style="flex-shrink: 0;">
        <v-btn icon dark @click="handleClose()" class="me-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <img :src="logo" alt="webcotacao" class="h-35px">
      </div>

      <!-- Breadcrumb -->
      <div class="px-6 py-2" style="flex-shrink: 0; background: white;">
        <div class="d-flex align-center" style="font-size: 14px;">
          <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Carrinho de Compras</span>
          <span class="mx-1" style="color: #9e9e9e;">></span>
          <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Cotação</span>
          <span class="mx-1" style="color: #9e9e9e;">></span>
          <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Nova Cotação</span>
          <span class="mx-1" style="color: #9e9e9e;">></span>
          <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">{{ cotacaoTitulo || '[Título da cotação]' }}</span>
          <span class="mx-1" style="color: #9e9e9e;">></span>
          <span class="mr-1" style="cursor: default; text-decoration: none; color: #424242;">Visualizar fornecedores</span>
          <span class="mx-1" style="color: #9e9e9e;">></span>
          <span class="px-2 py-1" style="background: #ECF1FF; border-radius: 4px; color: #1976d2; font-weight: 500;">Adicionar Fornecedores via Systock</span>
        </div>
      </div>

      <!-- Título com seta de voltar e campo de busca + botões -->
      <div class="px-6 py-4" style="flex-shrink: 0; background: white;">
        <div class="d-flex align-center justify-space-between mb-3">
          <!-- Título com seta de voltar -->
          <div class="d-flex align-center">
            <v-btn icon @click="handleClose()" class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="font-weight-medium mb-0" style="font-size: 18px;">Adicionar Fornecedores via Systock</h2>
          </div>

          <!-- Botão Adicionar à cotação -->
          <div>
            <v-btn
              class="wc-btn-actions"
              :disabled="selected.length === 0 || isAdicionando"
              @click="handleAdicionarFornecedores"
              :style="selected.length > 0 ? 'background-color: #4075FF; color: #FAFAFA; border-radius: 4px; padding: 8px 12px;' : 'background-color: #9e9e9e; color: white; border-radius: 4px; padding: 8px 12px;'"
            >
              Adicionar à cotação
            </v-btn>
          </div>
        </div>

        <!-- Campo de busca à esquerda -->
        <div>
          <v-text-field
            v-model="searchQuery"
            placeholder="Buscar por CNPJ, Razão Social ou Nome Fantasia"
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
            style="max-width: 500px;"
          ></v-text-field>
        </div>
      </div>

      <div
        class="content-body flex-grow-1 overflow-y-auto px-4"
        ref="scrollContainer"
      >
        <div>
          <sys-data-table
              ref="dataTable"
              class="wc-table-fixed-column"
              :headers="headers"
              :items="fornecedores"
              item-key="_itemId"
              v-model="selected"
              show-select
              :height="alturaTabela"
              item-height="50"
              :loading="isLoading"
          >
            <template #item.cnpj="{ item }">
              {{ formatCNPJ(item.cnpj) }}
            </template>

          </sys-data-table>

          <!-- Loading indicator para scroll infinito -->
          <div v-if="isLoadingMore" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Carregando mais fornecedores...</p>
          </div>

          <!-- Elemento sentinela para IntersectionObserver -->
          <div ref="scrollSentinel" style="height: 1px; width: 100%;"></div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import logo from "@/assets/logo_header.png";
import useVisualizarFornecedoresDialog from "@/components/webcotacao/composables/useVisualizarFornecedoresDialog";
import { ref, watch } from "vue";

const props = defineProps({
  visible: { type: Boolean },
  idCotacao: { type: Number },
  handleClose: { type: Function },
});

const emit = defineEmits(['fornecedores-adicionados']);

// Função para fechar o dialog
const handleClose = () => {
  if (props.handleClose) {
    props.handleClose();
  }
};

const dialogVisible = ref(false);

// Sincronizar com a prop visible
watch(() => props.visible, (newValue) => {
  dialogVisible.value = newValue;
}, { immediate: true });

const handleDialogInput = (value) => {
  dialogVisible.value = value;
};

const {
  isLoading,
  isLoadingMore,
  fornecedores,
  selected,
  headers,
  alturaTabela,
  cotacaoTitulo,
  searchQuery,
  formatCNPJ,
  scrollContainer,
  dataTable,
  scrollSentinel,
  isAdicionando,
  handleAdicionarFornecedores,
} = useVisualizarFornecedoresDialog(props, emit);
</script>

<style scoped>
</style>
